// extracted by mini-css-extract-plugin
module.exports = {"SuggestionContainer":"appointments__ClinicNameFilter__SuggestionContainer"};